// import React, { useEffect, useState } from "react";
// import { ReactComponent as ThumbsUpDownIcon } from "../../Icons/Union.svg";
// import { ReactComponent as ArrowUpIcon } from "../../Icons/thumbsUp.svg";
// import { ReactComponent as ArrowDownIcon } from "../../Icons/thumbDown.svg";
// import { ReactComponent as ArrowDownSelectedIcon } from "../../Icons/thumbsdownSelected.svg";
// import { ReactComponent as ArrowUpSelectedIcon } from "../../Icons/thumbsUpSelected.svg";
// import { ReactComponent as ThumbsUpDownTrueIcon } from "../../Icons/UnionTrue.svg";
// import { ReactComponent as ThumbsUpDownFalseIcon } from "../../Icons/UnionFalse.svg";
// import TooltipComp from "../ToolTip/TooltipComp";
// import { Rate } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import { rateRecommandedAnswer } from "../../API/api";
// import { bindActionCreators } from "redux";
// import { Actions } from "../../Action";
// import { toast } from "react-toastify";
// import { useLocation } from "react-router-dom";

// const submitRatingSuccessToast = (message) => {
//   return (
//     <>
//       <span style={{ fontSize: "12px" }}>{message}</span>
//     </>
//   );
// };
// export default function Rating({ id }) {
//   const ratingState = useSelector((state) => state.domain);
//   const currentPath=useLocation()
//   const dispatch = useDispatch();
//   const { updateSearchData2,getScrollPositionInExpertOpen } = bindActionCreators(Actions, dispatch);
//   const [value, setValue] = useState(
//     ratingState?.ratings === null||undefined
//       ? null
//       : ratingState?.ratings[id] === undefined||null
//       ? null
//       : ratingState?.ratings[id]
//   );
//   const renderValue = (data) => {
//     if (data === null || data === undefined) {
//       return null;
//     }
//     if (data.rating === null) {
//       return data.overallRating;
//     }
//     if (data.rating !== null) {
//       return data.rating;
//     }
//   };
//   const rateAnswer = (val) => {
//   if(currentPath.pathname.includes("/expertHome/answered")){
//     getScrollPositionInExpertOpen(window.scrollY)
//   }

   
//     if (val === null || val === undefined || val === 0) {
//       return;
//     }
//     let payload = {
//       rating: val,
//       answerUuid: value.answerUuidStr,
//       docId: value.docId,
//       feedback: value.feedback,
//     };
//     ratingState.ratings[id].rating = val;
//     updateSearchData2(ratingState.ratings);
//     rateRecommandedAnswer(payload).then((res) => {
//       if (res === undefined) return;
//       if (res.data.success) {
//         ratingState.ratings[id] = res.data.data;
//         updateSearchData2(ratingState.ratings);
//         toast.success(submitRatingSuccessToast(res.data.message));
//       }
//     });
//   };
//   const variable = () => {
//     return (
//       <>
//       <Rate
//         value={renderValue(value)}
//         onChange={(e) => rateAnswer(e)}
//       />
//       </>
//     );
//   };
//   useEffect(() => {
//     setValue(
//       ratingState.ratings === null
//         ? null
//         : ratingState.ratings[id] === undefined
//         ? null
//         : ratingState.ratings[id]
//     );
//   }, [ratingState.ratings]);

//   const ratingId=(val)=>{

//   }
//   return (
//     <>
//       <TooltipComp title={variable()}>
//         {renderValue(value) === null || renderValue(value) === undefined ? (
//           <>
//           <ThumbsUpDownIcon />
//           </>
//         ) : (
//           <>
//           <ThumbsUpDownFalseIcon />
//           </>
//         )}
//       </TooltipComp>
//     </>
//   );
// }



import React, { useEffect, useState } from "react";
import { ReactComponent as ThumbsUpDownIcon } from "../../Icons/Union.svg";
import { ReactComponent as ArrowUpIcon } from "../../Icons/thumbsUp.svg";
import { ReactComponent as ArrowDownIcon } from "../../Icons/thumbDown.svg";
import { ReactComponent as ArrowDownSelectedIcon } from "../../Icons/thumbsdownSelected.svg";
import { ReactComponent as ArrowUpSelectedIcon } from "../../Icons/thumbsUpSelected.svg";
import { ReactComponent as ThumbsUpDownTrueIcon } from "../../Icons/UnionTrue.svg";
import { ReactComponent as ThumbsUpDownFalseIcon } from "../../Icons/UnionFalse.svg";
import TooltipComp from "../ToolTip/TooltipComp";
import { Rate } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { rateRecommandedAnswer } from "../../API/api";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const submitRatingSuccessToast = (message) => {
  return <span style={{ fontSize: "12px" }}>{message}</span>;
};

export default function Rating({ id }) {
  const ratingState = useSelector((state) => state.domain);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const currentPath = useLocation();
  const dispatch = useDispatch();
  const { updateSearchData2, getScrollPositionInExpertOpen } = bindActionCreators(Actions, dispatch);

  const [value, setValue] = useState(() => ratingState?.ratings?.[id] ?? null);

  const renderValue = (data) => {
    if (!data) return null;
    return data.rating ?? data.overallRating ?? null;
  };

  const rateAnswer = (val) => {
    if (currentPath.pathname.includes("/expertHome/answered")) {
      getScrollPositionInExpertOpen(window.scrollY);
    }

    if (!val) return;

    const currentValue = ratingState?.ratings?.[id];
    if (!currentValue) return;

    const payload = {
      rating: val,
      answerUuid: currentValue.answerUuidStr,
      docId: currentValue.docId,
      feedback: currentValue.feedback,
    };

    ratingState.ratings[id].rating = val;
    updateSearchData2({ ...ratingState.ratings });

    rateRecommandedAnswer(payload).then((res) => {
      if (!res?.data?.success) return;

      ratingState.ratings[id] = res.data.data;
      updateSearchData2({ ...ratingState.ratings });
      toast.success(submitRatingSuccessToast(res.data.message));
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      rateAnswer(renderValue(value));
    }
  };

  const variable = () => (
    <Rate
      value={renderValue(value)}
      onChange={(e) => rateAnswer(e)}
      onKeyDown={(e) => handleKeyDown(e)}
    />
  );

  useEffect(() => {
    setValue(ratingState?.ratings?.[id] ?? null);
  }, [ratingState?.ratings, id]);

  return (
    <TooltipComp title={variable()} aria-label="Rate this answer">
      <div
        role="button"
        tabIndex={0}
        aria-label="Rate this answer"
        onClick={() => rateAnswer(renderValue(value))}
        onKeyDown={handleKeyDown}
        onFocus={() => setTooltipVisible(true)}
        onBlur={() => setTooltipVisible(false)}
        style={{ cursor: "pointer", display: "inline-block" }}
      >
        {renderValue(value) === null ? (
          <ThumbsUpDownIcon />
        ) : (
          <ThumbsUpDownFalseIcon />
        )}
      </div>
    </TooltipComp>
  );
}



  